import clsx from 'clsx';
import GreenCheckIcon from '../../assets/icons/check-green-icon.svg?react';
import React from 'react';
import Button from '../Button';
import { useButtonSizeLarge } from '../../utils/buttonSizes';
import { useNavigate } from 'react-router';
import { useLocalStorage } from '@uidotdev/usehooks';
import { LoginResponseData } from '@EHSNavigator/backend';

interface NotFoundProps {
  otherClasses?: string;
}

const NotFound: React.FC<NotFoundProps> = ({ otherClasses }) => {
  const NotFoundClasses = clsx(
    otherClasses,
    'flex flex-col items-center gap-12 px-25',
  );

  const [userInfo] = useLocalStorage<LoginResponseData | null>(
    'userInfo',
    null,
  );
  const navigate = useNavigate();

  const navigateTo = userInfo?.user?.id ? '/dashboard' : '/sign-in';
  const navigateTitle = userInfo?.user?.id
    ? 'Back to Dashboard'
    : 'Back to Sign In';
  return (
    <div className="flex h-screen items-center justify-center">
      <div className={NotFoundClasses} data-testid="NotFound">
        <GreenCheckIcon className="[&>path]:fill-brand-byzantine h-100 w-100 lg:h-150 lg:w-150" />
        <div className="flex flex-col gap-2.5 text-center">
          <h2 className={clsx('text-neutral-tones-text font-bold')}>
            This Page Can't Be Found.
          </h2>
          <div className="mx-auto max-w-812">
            <p className="font-inter-variable text-brand-byzantine text-2xl font-medium italic">
              Please use the navigation below to find what you're looking for,
              or contact support if you need further assistance.
            </p>
          </div>
        </div>
        <Button
          onClick={() => navigate(navigateTo)}
          otherClasses={clsx('max-w-465 w-full')}
          size={useButtonSizeLarge()}
        >
          {navigateTitle}
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
